import locale from "../../../utils/locale";
import { toTitleCase } from "../../../utils/textTransform";

export default [
  {
    name: "sellerName",
    label: locale("insuranceCompany"),
    type: "display",
    readable: true,
  },
  {
    name: "ownerName",
    label: locale("ownerName"),
    type: "display",
    readable: true,
  },
  {
    name: "lotNumber",
    getLabel: (sellerCompanyCode) => locale("lotNumber", { sellerCompanyCode }),
    type: "display",
    readable: true,
  },
  {
    name: "claimNumber",
    label: locale("claimNumber"),
    type: "display",
    readable: true,
  },
  {
    name: "vehicleYear",
    label: locale("vehicleYear"),
    type: "display",
    readable: true,
  },
  {
    name: "vehicleMake",
    label: locale("vehicleMake"),
    type: "display",
    readable: true,
  },
  {
    name: "vehicleModel",
    label: locale("vehicleModel"),
    type: "display",
    readable: true,
  },
  {
    name: "vehicleColor",
    label: locale("vehicleColor"),
    type: "display",
    readable: true,
  },
  {
    name: "vin",
    label: locale("vin"),
    type: "display",
    readable: true,
  },
];



// WEBPACK FOOTER //
// ./src/containers/PickupForm/fieldStructure/basicLotDetails.js